// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TeamSectionGroup-module__teamGroup___kSSbo {
  border: 1px solid #e4e4e7;
  border-radius: 7px;
  overflow: hidden;
  background: #ffffff;
}

.TeamSectionGroup-module__teamGroup___kSSbo + .TeamSectionGroup-module__teamGroup___kSSbo {
  margin-top: 10px;
}

.TeamSectionGroup-module__teamGroupDefault___aReF2 {
  border-color: #18181b;
}

.TeamSectionGroup-module__teamHeader___rk1Yj {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 10px 8px 10px 12px;
  background: #fafafa;
}

.TeamSectionGroup-module__teamHeader___rk1Yj:hover {
  background: #f4f4f5;
}

.TeamSectionGroup-module__teamHeaderDefault___pNOt0,
.TeamSectionGroup-module__teamHeaderDefault___pNOt0:hover {
  background: #f4f4f5;
}

.TeamSectionGroup-module__defaultBadge___m3zeq {
  flex-shrink: 0;
  font-size: 10px;
  font-weight: 600;
  color: #3f3f46;
  background: #e4e4e7;
  border-radius: 4px;
  padding: 1px 5px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.TeamSectionGroup-module__pinTeamButton___SJNi4 {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  padding: 0;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: #a1a1aa;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.TeamSectionGroup-module__pinTeamButton___SJNi4:hover {
  background: #e4e4e7;
  color: #52525b;
}

.TeamSectionGroup-module__pinTeamButton___SJNi4:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 1px;
}

.TeamSectionGroup-module__teamHeaderTrigger___U8BZp {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  text-align: left;
}

.TeamSectionGroup-module__teamHeaderTrigger___U8BZp:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TeamSectionGroup-module__copyTeamButton___UVJLk {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  padding: 0;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: #a1a1aa;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.TeamSectionGroup-module__copyTeamButton___UVJLk:hover {
  background: #e4e4e7;
  color: #52525b;
}

.TeamSectionGroup-module__copyTeamButton___UVJLk:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 1px;
}

.TeamSectionGroup-module__teamChevron___PQ6wh {
  flex-shrink: 0;
  color: #a1a1aa;
  transition: transform 0.15s ease;
}

.TeamSectionGroup-module__teamChevronCollapsed___KAmR_ {
  transform: rotate(-90deg);
}

.TeamSectionGroup-module__teamIcon___xj9Jd {
  flex-shrink: 0;
  font-size: 13px;
  color: #71717a;
}

.TeamSectionGroup-module__teamLabel___V7oPG {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  font-weight: 600;
  color: #18181b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.TeamSectionGroup-module__teamRollup___zu9y4 {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 500;
}

.TeamSectionGroup-module__rollupOpen___akVgR {
  color: #71717a;
}

.TeamSectionGroup-module__rollupDot___BuWfr {
  color: #d4d4d8;
}

.TeamSectionGroup-module__rollupDone___EY0x7 {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  color: #166534;
  font-weight: 600;
}

.TeamSectionGroup-module__teamProgressTrack___hA8V1 {
  height: 3px;
  background: #f4f4f5;
}

.TeamSectionGroup-module__teamProgressFill___gFyZE {
  height: 100%;
  transition: width 0.2s ease;
}

.TeamSectionGroup-module__teamProgressDone___y_Ztj {
  background: #22c55e;
}

.TeamSectionGroup-module__teamProgressActive___QrzK3 {
  background: #eab308;
}

.TeamSectionGroup-module__teamBody___biScO {
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.TeamSectionGroup-module__teamTasksBox____Pppk {
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  overflow: hidden;
}

.TeamSectionGroup-module__teamEmpty___MxYdq {
  font-size: 12px;
  color: #a1a1aa;
  padding: 4px 2px;
}

.TeamSectionGroup-module__teamEmptyDone___J_mK4 {
  color: #166534;
  font-weight: 500;
}

.TeamSectionGroup-module__completedSection___nacM3 {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.TeamSectionGroup-module__completedToggle___tMaO4 {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 4px;
  border: 0;
  background: transparent;
  color: #166534;
  cursor: pointer;
  font-size: 11px;
  font-weight: 600;
}

.TeamSectionGroup-module__completedToggle___tMaO4:hover {
  color: #14532d;
}

.TeamSectionGroup-module__completedToggle___tMaO4:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
  border-radius: 4px;
}

.TeamSectionGroup-module__completedChevron___MdeEz {
  flex-shrink: 0;
  width: 12px;
  height: 12px;
  transition: transform 0.15s ease;
}

.TeamSectionGroup-module__completedChevronCollapsed___RfPsr {
  transform: rotate(-90deg);
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/ReadinessDetail/TeamSectionGroup.module.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAIA;EACE,qBAAA;AADF;;AAIA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,2BAAA;EACA,mBAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAIA;;EAEE,mBAAA;AADF;;AAIA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AADF;;AAIA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AADF;;AAIA;EACE,mBAAA;EACA,cAAA;AADF;;AAIA;EACE,0BAAA;EACA,mBAAA;AADF;;AAIA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AADF;;AAIA;EACE,0BAAA;EACA,mBAAA;AADF;;AAIA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AADF;;AAIA;EACE,mBAAA;EACA,cAAA;AADF;;AAIA;EACE,0BAAA;EACA,mBAAA;AADF;;AAIA;EACE,cAAA;EACA,cAAA;EACA,gCAAA;AADF;;AAIA;EACE,yBAAA;AADF;;AAIA;EACE,cAAA;EACA,eAAA;EACA,cAAA;AADF;;AAIA;EACE,OAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAIA;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;AADF;;AAIA;EACE,WAAA;EACA,mBAAA;AADF;;AAIA;EACE,YAAA;EACA,2BAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AADF;;AAIA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;AADF;;AAIA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AADF;;AAIA;EACE,cAAA;EACA,gBAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AADF;;AAIA;EACE,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,0BAAA;EACA,mBAAA;EACA,kBAAA;AADF;;AAIA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;AADF;;AAIA;EACE,yBAAA;AADF","sourcesContent":[".teamGroup {\n  border: 1px solid #e4e4e7;\n  border-radius: 7px;\n  overflow: hidden;\n  background: #ffffff;\n}\n\n.teamGroup + .teamGroup {\n  margin-top: 10px;\n}\n\n// The pinned team is marked by a full border + deeper header tint — never a\n// side stripe, which would read as decoration rather than state.\n.teamGroupDefault {\n  border-color: #18181b;\n}\n\n.teamHeader {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 10px 8px 10px 12px;\n  background: #fafafa;\n}\n\n.teamHeader:hover {\n  background: #f4f4f5;\n}\n\n.teamHeaderDefault,\n.teamHeaderDefault:hover {\n  background: #f4f4f5;\n}\n\n.defaultBadge {\n  flex-shrink: 0;\n  font-size: 10px;\n  font-weight: 600;\n  color: #3f3f46;\n  background: #e4e4e7;\n  border-radius: 4px;\n  padding: 1px 5px;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.pinTeamButton {\n  flex-shrink: 0;\n  width: 22px;\n  height: 22px;\n  padding: 0;\n  border: 0;\n  border-radius: 4px;\n  background: transparent;\n  color: #a1a1aa;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.pinTeamButton:hover {\n  background: #e4e4e7;\n  color: #52525b;\n}\n\n.pinTeamButton:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 1px;\n}\n\n.teamHeaderTrigger {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n}\n\n.teamHeaderTrigger:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.copyTeamButton {\n  flex-shrink: 0;\n  width: 22px;\n  height: 22px;\n  padding: 0;\n  border: 0;\n  border-radius: 4px;\n  background: transparent;\n  color: #a1a1aa;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.copyTeamButton:hover {\n  background: #e4e4e7;\n  color: #52525b;\n}\n\n.copyTeamButton:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 1px;\n}\n\n.teamChevron {\n  flex-shrink: 0;\n  color: #a1a1aa;\n  transition: transform 0.15s ease;\n}\n\n.teamChevronCollapsed {\n  transform: rotate(-90deg);\n}\n\n.teamIcon {\n  flex-shrink: 0;\n  font-size: 13px;\n  color: #71717a;\n}\n\n.teamLabel {\n  flex: 1;\n  min-width: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #18181b;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.teamRollup {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.rollupOpen {\n  color: #71717a;\n}\n\n.rollupDot {\n  color: #d4d4d8;\n}\n\n.rollupDone {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  color: #166534;\n  font-weight: 600;\n}\n\n.teamProgressTrack {\n  height: 3px;\n  background: #f4f4f5;\n}\n\n.teamProgressFill {\n  height: 100%;\n  transition: width 0.2s ease;\n}\n\n.teamProgressDone {\n  background: #22c55e;\n}\n\n.teamProgressActive {\n  background: #eab308;\n}\n\n.teamBody {\n  padding: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.teamTasksBox {\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.teamEmpty {\n  font-size: 12px;\n  color: #a1a1aa;\n  padding: 4px 2px;\n}\n\n.teamEmptyDone {\n  color: #166534;\n  font-weight: 500;\n}\n\n.completedSection {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.completedToggle {\n  align-self: flex-start;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 4px;\n  border: 0;\n  background: transparent;\n  color: #166534;\n  cursor: pointer;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.completedToggle:hover {\n  color: #14532d;\n}\n\n.completedToggle:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n.completedChevron {\n  flex-shrink: 0;\n  width: 12px;\n  height: 12px;\n  transition: transform 0.15s ease;\n}\n\n.completedChevronCollapsed {\n  transform: rotate(-90deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"teamGroup": `TeamSectionGroup-module__teamGroup___kSSbo`,
	"teamGroupDefault": `TeamSectionGroup-module__teamGroupDefault___aReF2`,
	"teamHeader": `TeamSectionGroup-module__teamHeader___rk1Yj`,
	"teamHeaderDefault": `TeamSectionGroup-module__teamHeaderDefault___pNOt0`,
	"defaultBadge": `TeamSectionGroup-module__defaultBadge___m3zeq`,
	"pinTeamButton": `TeamSectionGroup-module__pinTeamButton___SJNi4`,
	"teamHeaderTrigger": `TeamSectionGroup-module__teamHeaderTrigger___U8BZp`,
	"copyTeamButton": `TeamSectionGroup-module__copyTeamButton___UVJLk`,
	"teamChevron": `TeamSectionGroup-module__teamChevron___PQ6wh`,
	"teamChevronCollapsed": `TeamSectionGroup-module__teamChevronCollapsed___KAmR_`,
	"teamIcon": `TeamSectionGroup-module__teamIcon___xj9Jd`,
	"teamLabel": `TeamSectionGroup-module__teamLabel___V7oPG`,
	"teamRollup": `TeamSectionGroup-module__teamRollup___zu9y4`,
	"rollupOpen": `TeamSectionGroup-module__rollupOpen___akVgR`,
	"rollupDot": `TeamSectionGroup-module__rollupDot___BuWfr`,
	"rollupDone": `TeamSectionGroup-module__rollupDone___EY0x7`,
	"teamProgressTrack": `TeamSectionGroup-module__teamProgressTrack___hA8V1`,
	"teamProgressFill": `TeamSectionGroup-module__teamProgressFill___gFyZE`,
	"teamProgressDone": `TeamSectionGroup-module__teamProgressDone___y_Ztj`,
	"teamProgressActive": `TeamSectionGroup-module__teamProgressActive___QrzK3`,
	"teamBody": `TeamSectionGroup-module__teamBody___biScO`,
	"teamTasksBox": `TeamSectionGroup-module__teamTasksBox____Pppk`,
	"teamEmpty": `TeamSectionGroup-module__teamEmpty___MxYdq`,
	"teamEmptyDone": `TeamSectionGroup-module__teamEmptyDone___J_mK4`,
	"completedSection": `TeamSectionGroup-module__completedSection___nacM3`,
	"completedToggle": `TeamSectionGroup-module__completedToggle___tMaO4`,
	"completedChevron": `TeamSectionGroup-module__completedChevron___MdeEz`,
	"completedChevronCollapsed": `TeamSectionGroup-module__completedChevronCollapsed___RfPsr`
};
module.exports = ___CSS_LOADER_EXPORT___;
